export const EMCO2List: any[] = [
  {
    deviceName: 'EMS-6500',
    payload: null
  },
  {
    deviceName: 'EMS-6962',
    payload: null
  },
  {
    deviceName: 'EMS-6968',
    payload: null
  },
  {
    deviceName: 'EMS-6993',
    payload: null
  }
];

